import Vue from "vue";
import VueRouter from "vue-router";
// logine
import Login from "../views/General/Login/vLogin.vue";
import  Registro from "../views/General/Login/vRegistro.vue"; 
import LoginPostulante from "../views/General/Login/vLoginPostulante";
import RegistrarPuestos from "@/views/Seleccion/vPuesto.vue";
import Aprobacion from "@/views/Seleccion/vPuestoAproba.vue";
import RegistroSolicitud from "@/components/ModSeleccion/Solicitud/RegistrarSolicitud.vue";

import EscogeMultiplataforma from "@/views/General/Acceso/vMultiplataforma.vue";
import Bienvenido from "../views/General/Acceso/vBienvenido.vue";
import Listado from "@/views/Seleccion/vPostulante.vue";
import Navbarse from "../views/navbar.vue";
import Error from "@/views/Error/vErrorRuta.vue";

//BASE DE DATOS POSTULANTE
import vFichaPostulante from "@/views/Seleccion/Seguimiento/FichaPostulante1.vue";

//OPCION: GESTION DE SOLICITUD
import GestionSolicitud from "@/views/Seleccion/vGestionSolicitud.vue";
import GestionDeSolicitud from "@/components/ModSeleccion/Gestion/GesSolicitud.vue";
import GestionDeSolicitudPostulante from "@/components/ModSeleccion/Gestion/GesPostulante.vue";

//ASIGNACION DE POSTULANTE EN LA SOLICITUD
import RegistroGestionSolicitud from "@/components/ModSeleccion/Gestion/AsignarPostulante/AsignarPostulante.vue";
import EditarListadoPostulante from "@/components/ModSeleccion/Gestion/AsignarPostulante/EditarPostulante.vue";
import UsuarioInfoPostulante from "@/components/ModSeleccion/Gestion/AsignarPostulante/FichaPostulante.vue";
import vRestriccionPostulante from "@/views/Seleccion/vRestriccionPostulante.vue";

//ETAPA SELECCION
import DatosDeSolicitud from "@/components/ModSeleccion/Gestion/EtapaSeleccion/DatosSolicitud.vue";
import SeleccionEstadoEdicion from "@/components/ModSeleccion/Gestion/EtapaSeleccion/GesSeleccion.vue";
//ETAPA ENTREVISTA
import DatosDeEntrevista from "@/components/ModSeleccion/Gestion/EtapaEntrevista/GesEntrevista.vue";
//ETAPA DOCUMENTOS
import DatosDeDocumentos from "@/components/ModSeleccion/Gestion/EtapaDocumento/GesDocumento.vue";
import DatosDeDocumentosFirma from "@/components/ModSeleccion/Gestion/EtapaDocumento/GesDocumentoPostulante.vue";

//ETAPA CAPACITACION
import DatosDeCapacitaciones from "@/components/ModSeleccion/Gestion/EtapaCapacitacion/GesCapacitacion.vue";

//OPCION: SEGUIMIENTO DE SOLICITUD
import GestionSolicitudXsolContra from "@/views/Seleccion/vSeguimientoSoli.vue";

import SeguimientoSolicitudContra from "@/views/vSeguimientoSolicitud.vue";

//ETAPA SELECCION
import SegSeleccion from "@/views/Seleccion/vEtapaSeleccion.vue";
//ETAPA ENTREVISTA
import SolicitudEntrevista from "@/components/ModSeleccion/Seguimiento/EtapaEntrevista/SegEntrevista.vue";
//ETAPA DOCUMENTOS
import SolicitudDocumentos from "@/components/ModSeleccion/Seguimiento/EtapaDocumento/SegDocumento.vue";
//ETAPA CAPACITACION
import ContratoEstadoDeCapacitacion from "@/components/ModSeleccion/Seguimiento/EtapaCapacitacion/SegCapacitacion.vue";
//ETAPA CONTRATOS
import EstadoDeContratos from "@/components/ModSeleccion/Seguimiento/EtapaContrato/SegContrato.vue";

//OPCION ACCESO
import AccesoRegistro from "@/views/General/Acceso/vAccRegistrar.vue";
import AccesoVisualizar from "@/views/General/Acceso/vAccVisualizar.vue";


//import Tecnologias from "@/components/DashboardPlat7/Tecnologia.vue";
import ContratoSeleccion from "../views/Seleccion/vEtapaContrato.vue";

import ListarReportes from "@/views/Seleccion/vRepSeleccion.vue";
import ListarReportesContra from "@/views/Contratos/vRepContrato.vue";
import RegistarEmpresaCc from "@/views/General/Acceso/vInsertarEmCc.vue";
import Autentication from "@/views/General/Login/vActualizarContraseña.vue";
import Haloween from "@/views/zzHalloween/Haloween.vue";
import Escoger from "@/views/zzHalloween/Escoger";
import Resultados from "@/views/zzHalloween/MostrarResultados.vue";
import ReporteContrato from "@/views/Contratos/vRepContrato.vue";

// Renovaciones
import RegistroRenovaciones from "@/views/Contratos/RegRenovacion/vRenIndividual.vue";
import RegistroRenovacionesMasiva from "@/views/Contratos/RegRenovacion/vRenMasiva";
import GestionRenovacion from "@/views/Contratos/vGesRenIndividual.vue";
import SeguimientoRenovacion from "@/views/Contratos/vSegRenovacion.vue";
import ReporteContratoRenova from "@/views/Contratos/ReporteContratoRenovacion/ReporteRenovacion.vue";
//Cese
import RegistroCeseIndi from "@/views/Cese/RegCese/vRegCesIndividual.vue";
import RegistroCeseMasivo from "@/views/Cese/RegCese/vRegCesMasivo.vue";
import GestionCese from "@/views/Cese/GesCese/vGesCese";
import SeguimientoCese from "@/views/Cese/SegCese/SeguimientoCese.vue";


// Periodo
import Periodo from "@/views/Contratos/vPeriodo.vue";

// Registro Trabajadores

import RegistrarTrabajadores from "@/components/ModContratos/RegistroDeTrabajadores/RegTrabajador.vue";

// OPERACIONES
import RegistroOperaciones from "@/views/RegistroTrabajador.vue";
import vMesaAyuda from "@/views/vMesaAyuda.vue";
import RegistroOperacionesLogueado from "@/views/RegistroTrabajador.vue";

import RegistroActivades from "@/views/ControlActividades.vue";

import ControlAsistencia1 from "@/views/Nominas/ControlAsistencia/vControlAsistencia.vue";
import PuntoVenta from "@/views/Nominas/ControlAsistencia/vPuntoDeVenta.vue";
import Horario from "@/views/Nominas/ControlAsistencia/vHorario.vue";
import Rutas1 from "@/views/Nominas/ControlAsistencia/vRuta.vue";

// CAPACITACIONES
import CapacitacionRegistro from "@/views/SeguridadSaludTrabajo/vRegCapacitacion.vue";

import CapacitacionInsertar from "@/views/SeguridadSaludTrabajo/vAccCapacitacion.vue";

import TesoreriaCuenta from "@/views/Tesoreria/vCuenta.vue";
import MantenimientoCuenta from "@/views/Contabilidad/vManCuenta.vue";
import ReporteExcelContabilidad from "../views/Contabilidad/vRepContabilidad.vue";

import CorreosTecnologias from "@/views/Tecnologia/vCorreoTecnologia.vue";

//import { component } from "vue/types/umd";

import Prefrecuentes from "@/components/ModContratos/PreFrecuentes/Prefrecuentes.vue";
import MisVideosContrato from "@/components/ModContratos/PreFrecuentes/MisVideos.vue";
import PreFContrato from "@/components/ModContratos/PreFrecuentes/PreFContrato.vue";
import ManualInstructivo1 from "@/components/ModContratos/PreFrecuentes/ManualInstructivo.vue";

// TECNOLOGIA
import LineasTelefonicas from "@/views/Tecnologia/Lineas/LineasTelefonicas.vue";
import DispositivosTecnologicos from "@/views/Tecnologia/Dipositivos/Dispositivos.vue";
import RotacionEquipo from "@/views/Tecnologia/rotacion/RotacionEquipo.vue";
import Historial from "@/views/Tecnologia/Historial/Historial.vue";
import SeguiRotacion from "@/views/Tecnologia/rotacion/SeguiRotacion.vue";
import DescuentoTecnologia from "@/views/Contratos/DesTecnologia/DescuentoTecnologia.vue";
import DescuentoTecnologiaParams from "@/views/Contratos/DesTecnologia/DescuentoParams.vue";
//Mi Perfil
import DatosGenerales from "@/views/MiPerfil/Datos_Generales/Datos.vue";
import ContratoRenovaciones from "@/views/MiPerfil/Contratos_Renovaciones/Contrato_Renovacion.vue";
import ContratoBoleta from "@/views/MiPerfil/Mis_Boletas/Mis_BoletasPrincipal.vue";
import Politicas from "@/views/MiPerfil/Politicas_Reglamentos/Politicas.vue";
import vVacaciones from "@/views/MiPerfil/Vacaciones/vVacaciones.vue";

//enfermeria
import CitaMedica from "@/views/Enfermeria/CitaMedica.vue";

//contabilidad
import Control_Procesos_Fac from "@/views/Contabilidad/Control_Procesos.vue";
import vSeguiSolicitud from "@/views/Seleccion/Seguimiento/vSeguiSolicitud.vue";

//BasePostulante
import BaseRqUsuarios from "@/views/Seleccion/BaseRq/BasesRqPostulantes/BaseRqUsuarios.vue";


//Inventario
import Inventario from "@/views/Inventario/Inventario.vue";

//Nominas
import BaseTrabajadores from "@/views/Nominas/BaseDeTrabajadores/BaseTrabajadores.vue";

//SST
import ListadoPuestos from "@/views/Seleccion/vPuestosVista.vue";


Vue.use(VueRouter);

const routes = [
  // {f

  //   path: "/",
  //   name: "escoger",
  //   component: Escoger,
  // },
  {
    path: "/",
    name: "login",
    component: Login,
  },

  {
    path: "/inventario",
    name: "inventeario",
    component: Inventario,
  },

   {
    path: "/registro",
    name: "registro",
    component: Registro,
  },

  {
    path: "/loginPostulante",
    name: "loginPostulante",
    component: LoginPostulante,
  },


  {
    path: "/validation",
    name: "Validacion",
    component: Autentication,
  },

  {
    path: "/ConcursoHaloween",
    name: "concursoHaloween",
    component: Haloween,
  },
  {
    path: "/ConcursoHaloweenEscoger",
    name: "concursoHaloweenEscoger",
    component: Escoger,
  },

  {
    path: "/ConcursoResultados",
    name: "ConcursoResultados",
    component: Resultados,
  },

  {
    path: "/Asistencia",
    name: "Asistencia",
    component: RegistroOperaciones,
  },
  
  {
    path: "/MesaAyuda",
    name: "MesaAyuda",
    component: vMesaAyuda,
  },

  {
    path: "/ControlActividades",
    name: "ControlActividades",
    component: RegistroActivades,
  },

  {
    path: "/Dashboard",
    //  name: "Navbarse",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Navbarse,
    meta: {
      autenticado: true,
    },

    children: [
      {
        path: "/Asistencia",
        name: "Asistencia",
        component: RegistroOperacionesLogueado,
      },

      {
        path: "",
        name: "multiplataforma",
        component: EscogeMultiplataforma,
      },

      {
        path: "/bienvenido",
        name: "bienvenido",
        component: Bienvenido,
      },

      {
        path: "/listado",
        name: "1",
        component: Listado,
      },

      {
        path: "/gestionSolicitudes",
        name: "variosGestion",
        component: GestionSolicitud,
      },

      {
        path: "/RegistroSolicitud",
        name: "28",
        component: RegistroSolicitud,
      },

      {
        path: "/registarPuestos",
        name: "31",
        component: RegistrarPuestos,
      },
        {
        path: "/AprobacionPuestos",
        name: "98",
        component: Aprobacion,
      },

      {
        path: "/SeguimientoSolicitud",
        name: "varios",
        component: vSeguiSolicitud,
      },
      {
        path: "/accesos",
        name: "57",
        component: AccesoRegistro,
      },

      {
        path: "/listasReporte",
        name: "58",
        component: ListarReportes,
      },

      {
        path: "/RegistrarEmpCc",
        name: "60",
        component: RegistarEmpresaCc,
      },

      {
        path: "/PuntoDeVentas",
        name: "67",
        component: PuntoVenta,
      },

      {
        path: "/Horarios",
        name: "68",
        component: Horario,
      },
      {
        path: "/DescuentoTecnologia",
        name: "61",
        component: DescuentoTecnologia,
      },

       {
        path: "/DescuentoTecnologiaParams/:id/:idPerfil",
        name: "DescuentoTecnologiaParams",
        component: DescuentoTecnologiaParams,
      },

      

      {
        path: "/Ruta",
        name: "69",
        component: Rutas1,
      },

      {
        path: "/ControlAsistencia",
        name: "70",
        component: ControlAsistencia1,
      },

      {
        path: "/RegistroCap",
        name: "71",
        component: CapacitacionRegistro,
      },

      {
        path: "/InsertarCap",
        name: "72",
        component: CapacitacionInsertar,
      },

      {
        path: "/tesoreriaCuentas",
        name: "73",
        component: TesoreriaCuenta,
      },

      {
        path: "/MantenimientoCuentas",
        name: "74",
        component: MantenimientoCuenta,
      },

      {
        path: "/ReporteExcelContabilidad",
        name: "75",
        component: ReporteExcelContabilidad,
      },

      {
        path: "/accesoVisualizacion",
        name: "accesoVisualizacion",
        component: AccesoVisualizar,
      },

      {
        path: "/usuarioinfo/:id",
        name: "usuarioinfo",
        component: vFichaPostulante,
      },

      {
        path: "/listasReporteContra",
        name: "listadoReportesContra",
        component: ListarReportesContra,
      },

      {
        path: "/gestionSolicitud/:ide",
        name: "gestionSolicitud",
        component: GestionDeSolicitud,
      },
      {
        path: "/gestionSolicitudPostulante/:postulante",
        name: "gestionSolicitudPostulante",
        component: GestionDeSolicitudPostulante,
      },

      {
        path: "/registroGestionSolicitud/:user",
        name: "registroGestionSolicitud",
        component: RegistroGestionSolicitud,
      },

      {
        path: "/datosSolicitud/:edit",
        name: "datosSolicitud",
        component: DatosDeSolicitud,
      },

      {
        path: "/datosEntrevista/:parametro",
        name: "datosEntrevista",
        component: DatosDeEntrevista,
      },
      {
        path: "/datosDocmuentos/:idSol",
        name: "26",
        component: DatosDeDocumentos,
      },
       {
        path: "/datosDocumentosFirmas/:idSol",
        name: "datosDocumentos",
        component: DatosDeDocumentosFirma,
      },

      {
        path: "/datosCapacitaciones/:idSol",
        name: "18",
        component: DatosDeCapacitaciones,
      },

      {
        path: "/contratosEstadoSeleccion/:ContratoSelect",
        name: "contratosEstadoSeleccion",
        component: SegSeleccion,
      },

      {
        path: "/contratosEstadoEntrevista/:ContratoEntre",
        name: "contratosEstadoEntrevista",
        component: SolicitudEntrevista,
      },

      {
        path: "/seguimientoSolcitudContra/:id",
        name: "seguimientoSolcitudContra",
        component: SeguimientoSolicitudContra,
      },
      {
        path: "/contratosEstadoDocumentos/:ContratoDoc",
        name: "contratosEstadoDocumentos",
        component: SolicitudDocumentos,
      },

      {
        path: "/contratosEstadoCapacitacion/:ContraVid",
        name: "contratosEstadoCapacitacion",
        component: ContratoEstadoDeCapacitacion,
      },

      {
        path: "/contratosEstadoContrat/:ContraCon",
        name: "contratosEstadoContrat",
        component: EstadoDeContratos,
      },

      {
        path: "/gestionSolicitudXsolContra/:id",
        name: "gestionSolicitudXsolContra",
        component: GestionSolicitudXsolContra,
      },

      {
        path: "/EditarListadoPostulante/:dnis",
        name: "editarListadoPostulante",
        component: EditarListadoPostulante,
      },
      {
        path: "/EditadoSeleccion/:use",
        name: "27",
        component: SeleccionEstadoEdicion,
      },
      {
        path: "/usuarioinfoPostulante/:ides",
        name: "usuarioinfoPostulante",
        component: UsuarioInfoPostulante,
      },

      {
        path: "/selectContrato/:contrato",
        name: "20",
        component: ContratoSeleccion,
      },

      // renovaciones

      {
        path: "/RegistroRenovaciones",
        name: "41",
        component: RegistroRenovaciones,
      },

      {
        path: "/RegistroRenovacionesMasiva",
        name: "RegistraRenovacionmasiva",
        component: RegistroRenovacionesMasiva,
      },

      {
        path: "/GestionRenovacionInd",
        name: "42",
        component: GestionRenovacion,
      },

      {
        path: "/SeguimientoRenovacion",
        name: "43",
        component: SeguimientoRenovacion,
      },

      {
        path: "/ReporteRenovacion",
        name:"100",
        component:ReporteContratoRenova
      },

      // CESES

      {
        path: "/RegistroCeseInd",
        name: "51",
        component: RegistroCeseIndi,
      },

      {
        path: "/RegistroCeseMasivo",
        name: "RegistroCeseMasivo",
        component: RegistroCeseMasivo,
      },

      {
        path: "/GestionCese",
        name: "55",
        component: GestionCese,
      },

      {
        path: "/SeguimientoCese",
        name: "106",
        component: SeguimientoCese,
      },
      
      {
        path: "/reporteContrato",
        name: "59",
        component: ReporteContrato,
      },

      // registro de trabajadores

      {
        path: "/RegistroDeTrabajadores",
        name: "56",
        component: RegistrarTrabajadores,
      },

      // Periodo

      {
        path: "/Periodo",
        name: "64",
        component: Periodo,
      },
      {
        path: "/CorreosTecnologia",
        name: "77",
        component: CorreosTecnologias,
      },
      {
        path: "/Restriccion",
        name: "78",
        component: vRestriccionPostulante,
      },

      {
        path: "/PreguntasFrecuentes",
        name: "79",
        component: Prefrecuentes,
      },

      {
        path: "/Videos",
        name: "MisVideos",
        component: MisVideosContrato,
      },
      {
        path: "/ManualInstructivo",
        name: "ManualInstructivo",
        component: ManualInstructivo1,
      },
      {
        path: "/PreFContrato",
        name: "PreFContratos",
        component: PreFContrato,
      },

      //perfil

      {
        path: "/DatosGenerales",
        name: "81",
        component: DatosGenerales,
      },
       {
        path: "/Vacaciones",
        name: "84",
        component: vVacaciones,
      },

      {
        path: "/ContratosRenovaciones",
        name: "82",
        component: ContratoRenovaciones,
      },

      {
        path: "/ContratosBoletas",
        name: "83",
        component: ContratoBoleta,
      },

      {
        path: "/ContratosPoliticas",
        name: "85",
        component: Politicas,
      },
      {
        path: "/CitaMedica",
        name: "90",
        component: CitaMedica,
      },

        {
        path: "/DispositivosTecnologicos",
        name: "91",
        component: DispositivosTecnologicos,
      },

      {
        path: "/LineasTelefonicas",
        name: "92",
        component: LineasTelefonicas,
      },    

      {
        path: "/RotacionEquipo",
        name: "93",
        component: RotacionEquipo,
      },
      {
        path: "/Historial",
        name: "95",
        component: Historial,
      },
       {
        path: "/SeguiRotacion",
        name: "96",
        component: SeguiRotacion,
      },


       {
        path: "/Procesos_Facturacion",
        name: "94",
        component: Control_Procesos_Fac,
      },

       {
        path: "/BaseRqUsuarios",
        name: "97",
        component: BaseRqUsuarios,
      },

       {
        path: "/BaseTrabajadores",
        name: "101",
        component: BaseTrabajadores,
      },
      
      {
        path: "/ListadoPuestos",
        name: "102",
        component: ListadoPuestos,
      },
      
      // {

      //   path :"",
      //   redirect: { name : 'home'}

      // },

      {
        path: "/:pathMatch(.*)*",
        // name: 'home',
        component: Error,
      },
    ],
  },

  {
    path: "/:pathMatch(.*)*",
    // name: 'home',
    component: Error,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem("access_token");
  // let entrada =localStorage.getItem("isSucces");
  let autenticado = to.matched.some((record) => record.meta.autenticado);

  if (autenticado && !token && localStorage.getItem("idPerfil") != 11) {
    next("/");
  } else if (!autenticado && token) {
    next("/Dashboard");
  } else {
    next();
  }
});

export default router;
